import {createElement} from "react";
import {render} from "react-dom";
import {BrowserRouter as Router, useLocation} from "react-router-dom";

function errorState(formErrors, field) {
    if (formErrors && formErrors[field] !== undefined) {
        return 'has-error';
    }
    return '';
}

function loadComponents(componentsMap) {
    jQuery('[data-ui-component]').each(function() {
        const ChildName = jQuery(this).data('ui-component'); //what component
        if (componentsMap[ChildName] !== undefined) {
            let args = jQuery(this).data('args'); //any extra arguments
            const withRouter = jQuery(this).attr('router');
            if (!args) {
                args = {};
            }

            args.component = ChildName; //pass component name into args, some components (i.e. form based) might use it to identify themselves.
            if (withRouter) {
                render(
                    <Router>
                        {createElement(componentsMap[ChildName], {args:args})}
                    </Router>,
                    jQuery(this)[0]
                );
            } else {
                render(
                    createElement(componentsMap[ChildName], {args:args}),
                    jQuery(this)[0]
                );
            }
        }
    })
}

function isDark(color) {

    // If RGB --> Convert it to HEX: http://gist.github.com/983661
    color = +("0x" + color.slice(1).replace(
            color.length < 5 && /./g, '$&$&'
        )
    );

    const r = color >> 16;
    const g = color >> 8 & 255;
    const b = color & 255;

    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    const hsp = Math.sqrt(
        0.299 * (r * r) +
        0.587 * (g * g) +
        0.114 * (b * b)
    );

    // Using the HSP value, determine whether the color is light or dark
    if (hsp>167.5) {
        return false;
    } else {
        return true;
    }
}

const valueFromId = (opts, id) => {
    return  opts.find(o => o.value === id);
    // const x = opts.find(o => o.value === id)
    // console.log('valueFromId', opts, id, x, typeof id);
    // return x
};

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

/**
 * Sets / updates properties of object to URL
 * @param data
 * @param history
 */
function updateQueryParams(data, history) {
    //On certain pages like admin.php there will be some query params that should be retained.
    let startingQuery = '';
    if (window.Huskies.startingQuery) {
        startingQuery = window.Huskies.startingQuery;
    }
    const params = new URLSearchParams(startingQuery);
    Object.entries(data).map(([key, item]) => {
        params.set(key, item);
    })
    history.push({search: params.toString()})
}

function animateScrollTo(selector, condition) {
    if (condition) {
        jQuery( 'html, body' ).animate( { scrollTop: jQuery(selector).first().offset().top - 150 } );
    }
}

/**
 * Returns true if on iOS device
 * @returns {boolean|boolean}
 */
function iOS() {
    return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

/**
 * Escapes strings for use in regualr expressions
 * @param string
 * @returns {*}
 */
function escapeForRegex(string) {
    return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

/*
 * Removes class from the class string
 */
function withoutClass(classString, classToRemove) {
    return classString.replace( new RegExp('(?:^|\\s)'+classToRemove+'(?!\\S)') ,'');
}

export { errorState, loadComponents , isDark, valueFromId, useQuery, updateQueryParams, animateScrollTo,  iOS,  escapeForRegex, withoutClass};

